import React, { Fragment } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram, FaInstagramSquare } from "react-icons/fa";
import "../../assets/css/scss/component/_footerSocial.scss";

export default function FooterSocialLink() {
    return (
        <Fragment>
            <ListGroup as="ul" className="list-unstyled mb-0 social d-flex align-items-center justify-content-center justify-content-md-start ml-xl-4">
                <ListGroup.Item as="li">
                    {/* <Link href='https://www.facebook.com/lcd.prize.7' to="/" target="_blank" title="Facebook">
                        <FaFacebookF />
                    </Link> */}
                    <a href='https://www.facebook.com/lcd.prize.7' target="_blank" title="Facebook" rel="noreferrer">
                        <FaFacebookF />
                    </a>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                    <a href='https://www.twitter.com/LCDPrize' target="_blank" title="Twitter" rel="noreferrer">
                        <FaTwitter />
                    </a>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                    <a href='https://www.instagram.com/lcdprize' target="_blank" title="Instagram" rel="noreferrer">
                        <FaInstagramSquare />
                    </a>
                </ListGroup.Item>
                {/* <ListGroup.Item as="li">
                    <Link to="/" target="_blank" title="YouTube">
                        <FaYoutube />
                    </Link>
                </ListGroup.Item> */}
            </ListGroup>
        </Fragment>
    )
}
